import { KpkApiVideoConfiguration } from "@keepeek/api-client";
import { REFERRER_SESSION_STORAGE_ITEM_NAME } from "@keepeek/commons";
import { PlayerViewerProps } from "@keepeek/refront-components";

export function convertToPlayerProps(
  conf: KpkApiVideoConfiguration,
  userId?: number,
): PlayerViewerProps {
  let referrer;
  if (sessionStorage.getItem(REFERRER_SESSION_STORAGE_ITEM_NAME) !== null) {
    referrer = sessionStorage.getItem(REFERRER_SESSION_STORAGE_ITEM_NAME);
  }
  return {
    baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT,
    autoplay: conf.autoplay,
    posterSrc: conf.posterSrc,
    sources: conf.sources.map((s) => {
      return {
        default: s.default,
        label: s.label,
        res: s.res,
        src: s.src,
        type: s.type || "",
      };
    }),
    theme: conf.theme.value || "fantasy",
    statistics: { ...conf.statistics, referrer, userId },
    tracks: conf.tracks,
    isContextualMenuDisabled: true,
  };
}
